export default "__VITE_ASSET__chR$3UoL__"